export type LikableContentObject = LikableCamelCase | LikableSnakeCase;
type LikableCamelCase = { liked: boolean; likesCount: number };

type LikableSnakeCase = { liked: boolean; likes_count: number };

export const patchContentObjectLike = <T extends LikableContentObject>(item: T, action: 'like' | 'unlike'): T => {
  const delta = action === 'like' ? 1 : -1;

  if ('likesCount' in item) {
    return { ...item, liked: !item.liked, likesCount: item.likesCount + delta };
  }

  /* eslint-disable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
  return { ...item, liked: !item.liked, likes_count: item.likes_count + delta };
  /* eslint-enable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
};
